export default "__VITE_ASSET__Bk6iKeKg__"